import { createConsumer } from '@rails/actioncable';
var fallbackConsumer = null;
export default function getFallbackConsumer() {
  return fallbackConsumer || (fallbackConsumer = createConsumer());
}